import { compose } from "recompose";

import { Card } from "@dpdgroupuk/mydpd-ui";
import { withTrack } from "@dpdgroupuk/react-event-tracker";

import { FOOTER } from "./constants/analytics";

export default compose(withTrack(FOOTER.LOAD))(Card.Footer);
